import * as R from "ramda";
import React, { Component, Fragment } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import ReceivingPartNOSDetail from "./receivingPartNOSDetail";
import ReceivingPartNOSFilter from "./receivingPartNOSFilter";
import { formGroupNOSCreate, tableColumns } from "../config";
import {
  flattenFormGroupObject,
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../Services/Api";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import M from "moment";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import {
  contructQueryParam,
  fetchDataAsync,
  getUserAccess,
} from "../../../../Services/Utils";
import SimplePrintTable from "../../../../modules/popup/SimplePrintTable";
import ErrorAction from "../../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { HttpStatus } from "../../../common/Constants";
import ReceivingPartNOSDetailView from "./receivingPartNOSDetailView";

class ReceivingPartNOS extends Component {
  constructor(props) {
    super(props);
    // this.tableColumns = tableColumns(
    //   this.handleModalDetailVisibility,
    //   this.handleOnDelete,
    //   this.handleModalDetailViewVisibility,
    //   this.state.userAccess
    // );
    this.initialFilterData = {
      startDate: "",
      endDate: "",
      shippingNo: "",
      receivedNo: "",
      partCode: "",
      partName: "",
      category: "",
      purchaseOrderNo: "",
    };
    this.initialSearch = {
      startDate: null,
      endDate: null,
    };
    this.state = {
      filterModalVisible: false,
      detailModalVisible: false,
      detailViewModalVisible: false,
      processModalVisible: false,
      alertModalVisible: false,
      printModalVisible: false,
      deleteModalVisible: false,
      selectedIndex: null,
      isViolation: false,
      isSubmitting: false,
      alertText: null,
      userAccess: null,
      selectedData: null,
      dataTable: [],
      dataCabang: [],
      dataDetail: null,
      selectedCabang: null,
      filterData: this.initialFilterData,
      search: this.initialSearch,
      pagination: {
        count: 10,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.setState((prevState) => ({
      ...prevState,
      search: {
        startDate: M(new Date()).format("DD-MM-YYYY"),
        endDate: M(new Date()).format("DD-MM-YYYY"),
      },
    }));
    await this.fetchDataCabang();
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (!R.equals(this.state.search.kodeCabang, prevState.search.kodeCabang)) {
      this.handleTriggerLoading();

      const payload = {
        ...this.state.search,
        kodeCabang: this.state.search.kodeCabang?.value || "",
        limit: this.state.pagination.limit,
        page: 1,
      };

      await this.fetchData(removeNullFields(payload));

      this.setState((prevState) => ({
        ...prevState,
        userAccess: getUserAccess(
          this.props.menuAccess,
          this.state.search.kodeCabang?.value,
        ),
      }));

      this.handleTriggerLoading();
    }
  };

  reloadCurrentPage = async () => {
    const { page, limit } = this.state.pagination;

    const paramFilters = !R.isEmpty(this.state.filterData)
      ? {
          ...removeNullFields(this.state.filterData),
          kodeCabang: this.state.search.kodeCabang?.value || "",
        }
      : {
          ...removeNullFields({
            ...this.state.search,
            kodeCabang: this.state.search.kodeCabang?.value || "",
          }),
        };

    await this.fetchData({
      ...paramFilters,
      page,
      limit,
    });
  };

  handleModalFilterVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      selectedCabang: this.state.search.kodeCabang,
      filterModalVisible: !prevState.filterModalVisible,
    }));
  };

  handleModalDetailVisibility = (index, mode = "edit") => {
    const selectedData =
      mode === "edit" && index !== undefined && this.state.dataTable[index]
        ? this.state.dataTable[index]
        : null;

    this.setState((prevState) => ({
      ...prevState,
      selectedData: selectedData,
      selectedCabang: this.state.search.kodeCabang,
      detailModalVisible: !prevState.detailModalVisible,
      detailMode: mode,
    }));
  };

  handleModalDetailViewVisibility = (index, mode = "view") => {
    const selectedData = mode === "view" ? this.state.dataTable[index] : null;

    this.setState((prevState) => ({
      ...prevState,
      selectedData: prevState.dataTable[index],
      selectedCabang: this.state.search.kodeCabang,
      detailViewModalVisible: !prevState.detailViewModalVisible,
      detailMode: mode,
    }));
  };

  handleViolationChange = (hasViolation) => {
    this.setState({ isViolation: hasViolation });
  };

  handleProcessModalVisibility = () => {
    this.handleModalDetailVisibility(null, "create");
  };

  handleAlertModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      alertText: text ? text : null,
      alertModalVisible: !prevState.alertModalVisible,
      deleteModalVisible: false,
      detailModalVisible: false,
    }));
  };

  handleInputDateChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: M(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleSearchValueChange = (name, value) => {
    const today = M(new Date()).format("DD-MM-YYYY");

    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        [name]: value,
        startDate: today,
        endDate: today,
      },
      pagination: {
        ...prevState.pagination,
        page: 1,
        limit: 5,
      },
    }));
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleOnSubmitSearch = async () => {
    this.handleTriggerLoading();
    await this.fetchData({
      ...removeNullFields({
        ...this.state.search,
        kodeCabang: this.state.search.kodeCabang?.value || "",
      }),
      limit: this.state.pagination.limit,
      page: 1,
    });
    this.handleClearFormFilter();
    this.handleTriggerLoading();
  };

  handleOnSubmitFilter = async () => {
    this.handleTriggerLoading();

    await this.fetchData({
      ...removeNullFields(this.state.filterData),
      kodeCabang: this.state.selectedCabang.value,
      limit: this.state.pagination.limit,
      page: 1,
    });

    this.handleClearSearch();
    this.handleModalFilterVisibility();
    this.handleTriggerLoading();
  };

  handleOnSubmit = async (data, action = "save") => {
    if (this.state.isSubmitting) return;

    this.setState({ isSubmitting: true });

    if (this.state.loading) return;
    this.handleTriggerLoading();

    try {
      const formGroup = flattenFormGroupObject(data);
      const isEdit = this.state.detailMode === "edit";
      const id = isEdit ? this.state.selectedData.id : null;

      const detailData = this.state.dataDetail || {
        QR: formGroup.partWithQR || [],
        NOQR: formGroup.partWithOutQR || [],
      };

      const hasViolation = [
        ...(detailData?.QR || []),
        ...(detailData?.NOQR || []),
      ].some((part) => part.isViolation === true);

      const mapPartArray = (parts) =>
        parts?.map((p) => ({
          partCode: p.partCode?.value || p.kode || "",
          partName: p.partName?.label || p.name || "",
          categoryName: p.categoryName || p.kategori || "",
          quantity: Number(p.quantity || p.jumlah || 0),
          purchaseOrderNo: p.purchaseOrderNo || p.noPo || "",
          orderType: p.orderType?.value || p.orderType || "",
          hotlineOrderNo: p.hotlineOrderNo || "",
          locatorId: p.locatorId?.value || p.locator?.value || "",
          locatorName: p.locatorId.label || p.locator?.label || "",
        })) || [];

      const requestBody = {
        id,
        receivingPartId: formGroup.receivingPartId,
        shippingNo: formGroup.shippingNo,
        numberOfSPBP: formGroup.numberOfSPBP,
        invoiceNo: formGroup.invoiceNo,
        receivedNo: formGroup.receivedNo || null,
        shippingDate: formGroup.shippingDate || null,
        supplierId: formGroup.supplierId?.value || formGroup.supplierId || null,
        supplierName: formGroup.supplierId?.name || null,
        carId: formGroup.carId || null,
        expeditionId:
          formGroup.expeditionId?.value || formGroup.expeditionId || null,
        expeditionName: formGroup.expeditionId?.name || null,
        note: formGroup.note || null,
        kodeCabang: this.state.search.kodeCabang?.value,
        hasViolation: isEdit ? hasViolation : false,
        receivingPartSource: "NOS",
        partWithQR: mapPartArray(formGroup.partWithQR),
        partWithOutQR: mapPartArray(formGroup.partWithOutQR),
      };

      console.log(requestBody);

      // const res = await fetchDataAsync({
      //   asyncFn: Api.create("NAGAMAS_TRANSACTION").submitReceivingPartNOS,
      //   menuName: "Receiving part - NOS",
      //   setError: this.props.setError,
      //   args: requestBody,
      // });
      const res = await Api.create(
        "NAGAMAS_TRANSACTION",
      ).submitReceivingPartNOS(requestBody);

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        await this.reloadCurrentPage();

        if (R.equals(action, "save")) {
          this.handleProcessModalVisibility();
        } else {
          this.handleModalDetailVisibility();
        }

        this.handleAlertModalVisibility("Data Telah Disimpan.");
      } else {
        this.handleAlertModalVisibility(res.data.message);
      }
    } finally {
      this.setState({ isSubmitting: false });
      this.handleTriggerLoading();
    }
  };

  handleOnDelete = async (index) => {
    this.setState((prevState) => ({
      ...prevState,
      selectedIndex: index,
    }));
    this.handleModalDeleteVisibility();
  };

  handleSubmitDelete = async () => {
    let id = this.state.dataTable[this.state.selectedIndex].receivingPartId;

    try {
      this.handleTriggerLoading();
      let res = await Api.create("NAGAMAS_TRANSACTION").deleteReceivingPartNOS(
        contructQueryParam({
          receivingPartId: id,
        }),
      );

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.handleAlertModalVisibility("Data Telah Dihapus.");
        // this.handleModalDeleteVisibility();
        await this.reloadCurrentPage();
      } else {
        this.handleAlertModalVisibility(res.data.message);
      }

      this.handleTriggerLoading();
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handlePrint = async () => {
    console.log(this.state.dataTable);
    this.handleTriggerLoading();

    const reqBody = {
      filename: "RECEIVING_PART",
      sheets: [
        {
          name: "RECEIVING PART",
          headers: [
            "No",
            "No SPBP",
            "Tanggal SPBP",
            "Tanggal SL",
            "No. SL",
            "Nama Supplier",
            "Jumlah",
          ],
          data: this.state.dataTable.map((item, index) => ({
            No: index + 1,
            "No SPBP": item.numberOfSPBP,
            "Tanggal SPBP": item.dateOfSPBP,
            "Tanggal SL": item.shippingDate,
            "No. SL": item.shippingNo,
            "Nama Supplier": item.supplierName,
            Jumlah: item.quantity,
          })),
        },
      ],
    };

    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelPart,
        menuName: "Receiving Part",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "RECEIVING_PART.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
    }

    this.handleTriggerLoading();
  };

  handleClearFormFilter = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: {
        ...prevState.filterData,
        ...this.initialFilterData,
      },
    }));
  };

  handleClearSearch = () => {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        ...this.initialSearch,
      },
    }));
  };

  handleChangePage = async (tableState) => {
    this.handleTriggerLoading();
    const limit = tableState.rowsPerPage;
    const page = tableState.page + 1;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page,
        limit,
      },
    }));

    const paramFilters = !R.isEmpty(this.state.filterData)
      ? {
          ...removeNullFields(this.state.filterData),
          kodeCabang: this.state.search.kodeCabang.value,
        }
      : { ...removeNullFields(this.state.search) };

    await this.fetchData({
      ...paramFilters,
      page,
      limit,
    });
    this.handleTriggerLoading();
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.handleTriggerLoading();
    const limit = tableState.rowsPerPage;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit,
      },
    }));

    const paramFilters = !R.isEmpty(this.state.filterData)
      ? {
          ...removeNullFields(this.state.filterData),
          kodeCabang: this.state.search.kodeCabang.value,
        }
      : { ...removeNullFields(this.state.search) };

    await this.fetchData({
      ...paramFilters,
      page: 1,
      limit,
    });
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchData = async (body) => {
    try {
      let res = await Api.create(
        "NAGAMAS_TRANSACTION",
      ).getAllReceivingPartNOSByParam(
        body && Object.keys(body).length > 0 ? body : { page: 1, limit: 5 },
      );

      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: res.data?.data?.map((data) => {
            return {
              ...data,
            };
          }),
          pagination: {
            ...prevValue.pagination,
            count: res.data.totalData ? res.data.totalData : 5,
          },
        }));
      }
    } catch (e) {
      console.log("errors: ", e);
    }
  };

  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang),
        );

        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData,
            search: {
              ...prevValue.search,
              kodeCabang: mapToObjectDDL(
                filteredData[0].namaDealer,
                filteredData[0].kodeCabang,
              ),
            },
            userAccess: getUserAccess(
              this.props.menuAccess,
              filteredData[0].kodeCabang,
            ),
          }));
        }
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  parseFilterData(data) {
    const rfsStatus = getValueFromDDL(data, "rfsStatus");
    const parsedRfsStatus = R.isNil(rfsStatus)
      ? null
      : rfsStatus === true
        ? "RFS"
        : rfsStatus === false
          ? "NRFS"
          : null;
    const yearManufactured = !R.isNil(data.yearManufactured)
      ? Number(data.yearManufactured)
      : null;

    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
      variantCode: getValueFromDDL(data, "variantCode"),
      colorCode: getValueFromDDL(data, "colorCode"),
      locatorCode: getValueFromDDL(data, "locatorCode"),
      manual: getValueFromDDL(data, "manual"),
      rfsStatus: parsedRfsStatus,
      yearManufactured: yearManufactured,
    };
  }

  handleModalDeleteVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      deleteModalVisible: !prevState.deleteModalVisible,
    }));
  };

  render() {
    const columns = tableColumns(
      this.handleModalDetailVisibility,
      this.handleOnDelete,
      this.handleModalDetailViewVisibility,
      this.state.userAccess,
      this.state.pagination
    );

    return (
      <>
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
          className="margin-top-5px"
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={this.state.search.kodeCabang}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />

            <p className="margin-left-25px margin-bottom-20px">Periode</p>
            <SimpleDate
              id="select_date_from"
              // nextdate
              date={this.state.search.startDate}
              // maxDate={this.state.search.endDate}
              onChange={(value) =>
                this.handleInputDateChange("startDate", value)
              }
            />
            <SimpleDate
              id="select_date_to"
              backdate
              date={this.state.search.endDate}
              minDate={this.state.search.startDate}
              onChange={(value) => this.handleInputDateChange("endDate", value)}
            />
            <SimpleButton
              onClick={this.handleOnSubmitSearch}
              className="margin-bottom-20px"
            >
              Cari
            </SimpleButton>
          </FlexView>
          <SimpleButton
            className={"btn background-red margin-bottom-20px"}
            styles={{ width: "unset" }}
            onClick={this.handleModalFilterVisibility}
            icon={<i className="fa fa-qrcode"></i>}
          />
        </FlexView>

        <SimpleDataTable
          key={`${this.state.pagination.page}-${this.state.pagination.limit}`}
          data={this.state.dataTable}
          // columns={this.tableColumns}
          columns={columns}
          toCount={this.state.pagination.count}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          options={defaultTableChange(
            (tableState) => this.handleChangePage(tableState),
            (tableState) => this.handleChangeRowsPerPage(tableState),
          )}
          footerAdditionalButtons={
            <Fragment>
              {this.state.userAccess && this.state.userAccess.createAccess && (
                <SimpleButton
                  onClick={() => this.handleProcessModalVisibility()}
                  text={"Tambah"}
                />
              )}

              <SimpleButton
                onClick={() => this.handlePrint()}
                icon={<i className="fa fa-lw fa-print margin-right-10px"></i>}
                text={"Cetak"}
              />
            </Fragment>
          }
        />

        {this.state.filterModalVisible && (
          <ReceivingPartNOSFilter
            setError={this.props.setError}
            selectedData={this.state.filterData}
            selectedCabang={this.state.selectedCabang}
            visible={this.state.filterModalVisible}
            onValueChange={this.handleFilterValueChange}
            onSubmit={this.handleOnSubmitFilter}
            onClearForm={this.handleClearFormFilter}
            onClickClose={this.handleModalFilterVisibility}
          />
        )}

        {this.state.detailModalVisible && (
          <ReceivingPartNOSDetail
            setError={this.props.setError}
            mode={this.state.detailMode}
            formGroup={formGroupNOSCreate}
            initialValues={this.state.selectedData}
            selectedCabang={this.state.selectedCabang}
            userAccess={this.state.userAccess}
            visible={this.state.detailModalVisible}
            onSubmit={this.handleOnSubmit}
            isSubmitting={this.state.isSubmitting}
            loading={this.state.loading}
            onViolationChange={this.handleViolationChange}
            onClickClose={this.handleModalDetailVisibility}
          />
        )}

        {this.state.detailViewModalVisible && (
          <ReceivingPartNOSDetailView
            setError={this.props.setError}
            mode={this.state.detailMode}
            formGroup={formGroupNOSCreate}
            initialValues={this.state.selectedData}
            selectedCabang={this.state.selectedCabang}
            userAccess={this.state.userAccess}
            visible={this.state.detailViewModalVisible}
            onSubmit={this.handleOnSubmit}
            onViolationChange={this.handleViolationChange}
            onClickClose={this.handleModalDetailViewVisibility}
          />
        )}

        {/* {this.state.processModalVisible && (
          <ReceivingPartNOSProcess
            setError={this.props.setError}
            formGroup={formGroupNOSCreate}
            initialValues={this.state.selectedData}
            selectedCabang={this.state.selectedCabang}
            visible={this.state.processModalVisible}
            onSubmit={this.handleOnSubmit}
            onClickClose={this.handleProcessModalVisibility}
          />
        )} */}

        {this.state.alertModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={this.state.alertText}
            visible={this.state.alertModalVisible}
            onClickClose={this.handleAlertModalVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleAlertModalVisibility()}
              />
            }
          />
        )}

        {this.state.deleteModalVisible && (
          <SimpleAlert
            title={"Warning!"}
            content={"Apakah anda yakin ingin menghapus data ini?"}
            visible={this.state.deleteModalVisible}
            onClickClose={this.handleModalDeleteVisibility}
            // onSubmit={this.handleSubmitDelete}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Batal"
                  onClick={() => this.handleModalDeleteVisibility()}
                />
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Iya"
                  onClick={() => this.handleSubmitDelete()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.printModalVisible && (
          <SimplePrintTable onClearPrint={this.handlePrint} />
        )}
        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(ReceivingPartNOS);
